<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">Add User</h3>
            </div>
            <v-form
              class="v-form-body"
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <label class="form-control-label">
                    First Name
                    <span class="red--text">*</span>
                  </label>
                  <v-text-field
                    v-model="user.firstName"
                    placeholder="Enter First Name"
                    :rules="[(v) => !!v || 'First Name is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                    required
                    solo
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <label class="form-control-label">
                    Last Name
                    <span class="red--text">*</span>
                  </label>
                  <v-text-field
                    v-model="user.lastName"
                    placeholder="Enter Last Name"
                    :rules="[(v) => !!v || 'Last Name is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                    required
                    solo
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <label class="form-control-label">
                    Email
                    <span class="red--text">*</span>
                  </label>
                  <v-text-field
                    v-model="user.email"
                    :rules="emailRules"
                    placeholder="E-mail"
                    required
                    solo
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <label class="form-control-label">
                    Password
                    <span class="red--text">*</span>
                  </label>
                  <v-text-field
                    v-model.trim="user.password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.regex]"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    placeholder="Password"
                    hint="Password must contain an upper case letter, a numeric character, and a special character"
                    counter
                    @click:append="show1 = !show1"
                    solo
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <label class="form-control-label">
                    Role
                    <span class="red--text">*</span>
                  </label>
                  <v-select
                    v-model="user.role"
                    :items="roles"
                    :rules="[(v) => !!v || 'Role is required']"
                    label="Select Role"
                    item-value="_id"
                    item-text="name"
                    solo
                    required
                    @change="checkRole"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="permissions-combobox">
                  <label class="form-control-label">
                    Section / Menu Permissions
                  </label>
                  <v-combobox
                    v-model="user.modules"
                    :items="modulesList"
                    item-text="title"
                    item-value="value"
                    label="Select Permissions"
                    multiple
                    solo
                    small-chips
                    clearable
                    class="permission-dropdown"
                    hide-details
                    :loading="modulesListLoading"
                    :return-object="false"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <v-checkbox
                            v-model="selectAllField"
                            hide-details
                            @change="selectAllModules"
                            class="ma-0"
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title> Select All </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-combobox>
                </v-col>

                <v-col cols="3" sm="6" md="6" lg="6" xl="6">
                  <v-card-title class="pa-0">
                    <h4>Active</h4>
                    <v-switch
                      class="pl-4 pt-3 mt-0"
                      v-model="user.isActive"
                      inset
                    ></v-switch>
                  </v-card-title>
                </v-col>

                <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                  <v-card-title class="pa-0">
                    <h4>
                      Remain Anonymous
                      <v-tooltip bottom max-width="250">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            class="mdi mdi-information-outline"
                            v-bind="attrs"
                            v-on="on"
                            small
                          ></v-icon>
                        </template>
                        <span>Invisible from user's list in community.</span>
                      </v-tooltip>
                    </h4>
                    <v-switch
                      class="pl-4 pt-3 mt-0"
                      v-model="user.anonymity"
                      inset
                    ></v-switch>
                  </v-card-title>
                </v-col>

                <v-col cols="3" sm="6" md="6" lg="6" xl="6">
                  <v-card-title class="pa-0">
                    <h4>Visible to Patient?
                    <v-tooltip bottom max-width="250">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="mdi mdi-information-outline"
                          v-bind="attrs"
                          v-on="on"
                          small
                        ></v-icon>
                      </template>
                      <span>Visible to patient portal.</span>
                    </v-tooltip>
                    </h4>
                    <v-switch
                      class="pl-4 pt-3 mt-0"
                      v-model="user.isPatient"
                      inset
                    ></v-switch>
                  </v-card-title>
                </v-col>

                <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                  <v-card-title class="pa-0">
                    <h4>
                      Contact Admin
                      <v-tooltip bottom max-width="250">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            class="mdi mdi-information-outline"
                            v-bind="attrs"
                            v-on="on"
                            small
                          ></v-icon>
                        </template>
                        <span>Contact Admins for Further Assistance.</span>
                      </v-tooltip>
                    </h4>
                    <v-switch
                      class="pl-4 pt-3 mt-0"
                      v-model="user.isAdmin"
                      inset
                    ></v-switch>
                  </v-card-title>
                </v-col>

                <v-col cols="4" sm="6" md="6" lg="6" xl="6">
                  <v-card-title class="pa-0">
                    <h4>
                      Email Notifications
                      <v-tooltip bottom max-width="250">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            class="mdi mdi-information-outline"
                            v-bind="attrs"
                            v-on="on"
                            small
                          ></v-icon>
                        </template>
                        <span>This user will get email notification, when new user will be registered.</span>
                      </v-tooltip>
                    </h4>
                    <v-switch
                      class="pl-4 pt-3 mt-0"
                      v-model="user.isAllowNotification"
                      inset
                    ></v-switch>
                  </v-card-title>
                </v-col>

                <v-col cols="4" sm="6" md="6" lg="6" xl="6" v-if="isAdminRole">
                  <v-card-title class="pt-8 pl-0">
                    <h4>
                      Get Notification?
                      <v-tooltip bottom max-width="250">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            class="mdi mdi-information-outline"
                            v-bind="attrs"
                            v-on="on"
                            small
                          ></v-icon>
                        </template>
                        <span
                          >This admin will get email notification, when new user
                          will be registered.</span
                        >
                      </v-tooltip>
                    </h4>
                    <v-switch
                      class="pl-4 pt-3 mt-0"
                      v-model="user.isNotification"
                      inset
                    ></v-switch>
                  </v-card-title>
                </v-col>

                <v-col cols="12" sm="6" md="6" lg="6" xl="6" v-if="isAdminRole">
                  <v-card-title class="pt-8 pl-0">
                    <h4>
                      Contact us
                      <v-tooltip bottom max-width="250">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            class="mdi mdi-information-outline"
                            v-bind="attrs"
                            v-on="on"
                            small
                          ></v-icon>
                        </template>
                        <span>Contact for enquiries related.</span>
                      </v-tooltip>
                    </h4>
                    <v-switch
                      class="pl-4 pt-3 mt-0"
                      v-model="user.contactUs.isActive"
                      inset
                    ></v-switch>
                  </v-card-title>
                </v-col>

                <v-col cols="12" sm="12" md="12" v-if="isAdminRole && user.contactUs.isActive">
                  <label class="form-control-label">
                    Contact us Description
                  </label>
                  <v-textarea
                    v-model="user.contactUs.description"
                    placeholder="Enter description for Contact us"
                    solo
                    rows="2"
                  ></v-textarea>
                </v-col>

                <v-col class="text-right" cols="12">
                  <v-btn
                    color="#989898"
                    class="mr-4 white--text"
                    @click="cancel"
                    >Cancel</v-btn
                  >
                  <v-btn
                    :disabled="!valid"
                    color="#344452"
                    class="white--text"
                    :loading="loading"
                    @click="validate"
                    >Add</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CommonSection from "@/components/CommonHeader";
import { UserService, RoleService } from "@/services";

export default {
  name: "AddUser",
  components: {
    CommonSection,
  },
  data: function () {
    return {
      loading: false,
      valid: true,
      roles: [],
      emailRules: [
        (v) => !!v || "E-mail is required!",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      show1: false,
      rules: {
        required: (value) => !!value || "Password is required!",
        regex: (v) =>
          /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
            v
          ) ||
          "Password must contain an upper case letter, a numeric character, and a special character",
      },
      user: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        role: null,
        anonymity: false,
        isActive: true,
        step: 3,
        isPatient: false,
        isAdmin: false,
        contactUs: {
          isActive: false,
          description: null,
        },
        isNotification: false,
        isAllowNotification: true,
        modules: [],
      },
      isAdminRole: false,
      selectAllField: false,
      modulesList: [],
      modulesListLoading: false,
    };
  },
  watch: {
    "user.modules": function (values) {
      this.selectAllField =
        this.modulesList.length == values.length ? true : false;
    },
  },
  methods: {
    selectAllModules(event) {
      this.user.modules = [];
      if (event) {
        this.modulesList.forEach((objectData) => {
          this.user.modules.push(objectData.value);
        });
      }
    },
    async getRouteList() {
      this.modulesListLoading = true;
      const response = await RoleService.routeList();
      const modulesObjects =
        response.data.moduleList.modules.length > 0
          ? response.data.moduleList.modules[0]
          : [];

      this.modulesList = [];
      Object.values(modulesObjects).forEach((element) => {
        this.modulesList.push(element);
      });
      this.modulesListLoading = false;
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await UserService.createUser(this.user);
          this.loading = false;
          if (response) {
            this.$router.push("/users");
            this.$store.dispatch("user/setSnack", "User added successfully!");
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    cancel() {
      this.$router.push("/users");
    },
    checkRole(val) {
      const index = this.roles.findIndex((element) => element._id === val);
      let selectedRole = this.roles[index].name || "";
      this.isAdminRole = selectedRole == "Admin" ? true : false;
    },
  },
  async beforeMount() {
    const roleNames = await UserService.getRolesList();
    this.roles = roleNames.data.data.filter((element) => {
      return element.active === true;
    });
    this.getRouteList();
  },
};
</script>